module.exports = __webpack_public_path__ + "static/MARK_SIX-c43c4b90f986bfab089a12e683ca8bd3.png";